import { createFileRoute } from '@tanstack/react-router'
import { NotificationsConfigSettings } from '@/features/organizations/settings/notifications-config'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/notifications-config'
)({
  component: NotificationsConfigSettings,
})
